import Typography from '@mui/material/Typography';
import { useWatch } from 'react-hook-form';

import { useHasCloverOptInMessageFeature } from 'reservations/account/hooks/featureFlags';
import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import { marketingOptInMessageDisplayHelper } from 'reservations/form/helpers/marketingOptInMessageDisplay';

function MarketingFinePrint() {
  const hasCloverOptInMessageFeature = useHasCloverOptInMessageFeature();
  const restaurantName = useRestaurantName();
  const isEmailOptIn = useWatch({
    name: 'optInMarketingEmail',
    defaultValue: false
  });
  const isSmsOptIn = useWatch({
    name: 'optInMarketingSms',
    defaultValue: false
  });

  return (
    <>
      {hasCloverOptInMessageFeature ? (
        marketingOptInMessageDisplayHelper(
          isEmailOptIn,
          isSmsOptIn,
          restaurantName
        )
      ) : (
        <Typography variant="caption">
          By checking the text message box, I consent to receive automated
          offers and reward messages at the number provided from the merchant
          and/or its partners and confirm that I agree with your Privacy Policy
          and Terms of Service. Consent is not a condition to purchase. Msg&Data
          rates may apply. Msg frequency varies. Text STOP/HELP at any time.
        </Typography>
      )}
    </>
  );
}

export default MarketingFinePrint;
